<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-row>
      <v-col cols="12" sm="auto">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-top="-10"
          offset-y
          content-class="w-full md:w-96"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" x-large width="100%">
              <v-icon class="mr-2"> mdi-filter-variant </v-icon>
              Điều kiện lọc
            </v-btn>
          </template>

          <v-card class="px-8 pt-8 pb-2 flex flex-col space-y-4">
            <!--VSelect - Vuetify-->
            <v-select
              class="text-left mr-s"
              label="Trạng thái"
              align-self="end"
              prepend-inner-icon="mdi-list-status"
              no-data-text="Không có dữ liệu"
              color="#FBB040"
              item-text="name"
              item-value="id"
              v-model="fixStatus"
              :items="fixStatusList"
              :hide-details="true"
              outlined
              clearable
              @change="(value) => routeChange({ ...$route.query, fixStatus: value })"
            />
            <DatePicker
              v-model="startDate"
              @input="(value) => routeChange({ ...$route.query, startDate: value })"
              label="Từ ngày"
            />
            <DatePicker
              v-model="endDate"
              @input="(value) => routeChange({ ...$route.query, endDate: value })"
              label="Tới ngày"
            />
            <!--VSelect - Vuetify-->
            <!-- <v-select
              v-model="sortCondition"
              :items="sortConditionList"
              class="text-left"
              label="Thứ tự mặc định"
              align-self="end"
              prepend-inner-icon="mdi-sort-alphabetical-descending"
              no-data-text="Không có dữ liệu"
              color="#FBB040"
              item-text="name"
              item-value="id"
              :hide-details="true"
              outlined
              clearable
              @change="(value) => routeChange({ ...$route.query, sortCondition: value })"
            /> -->

            <v-card-actions>
              <v-spacer />
              <v-btn text @click="menu = false"> Đóng </v-btn>
              <v-btn color="primary" text @click="onClickDefault"> Mặc định </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
      <v-col
        cols="12"
        lg="auto"
        sm="6"
        class="flex-grow"
        v-if="role == 'Admin' || role == 'BocThuoc'"
      >
        <v-text-field
          v-model="searchString"
          hide-details="false"
          placeholder="Nội dung cần tìm"
          outlined
          color="#FBB040"
          prepend-inner-icon="mdi-magnify"
          @change="onSearch"
          clearable
        />
      </v-col>
      <v-col cols="12" lg="auto" class="flex-grow" sm="6" v-if="role == 'BacSy'">
        <v-text-field
          v-model="searchString"
          hide-details="false"
          placeholder="Nội dung cần tìm"
          outlined
          color="#FBB040"
          prepend-inner-icon="mdi-magnify"
          @change="onSearch"
          clearable
        />
      </v-col>
      <v-col cols="12" lg="2" sm="3" v-if="role == 'Admin' || role == 'BocThuoc'">
        <v-btn
          block
          color="success"
          min-width="180"
          width="100%"
          @click="createNewPhoneFix"
          x-large
        >
          <v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
          Tạo mới
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-8 mb-8" justify="center" align="center">
      <v-col cols="12" lg="9" md="7" sm="8" :class="classStyle">
        <span class="text-lg font-medium">Tổng số: {{ totalItems }}</span>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-skeleton-loader
      ref="skeleton_heading"
      :loading="isLoading"
      transition="scale-transition"
      :boilerplate="false"
      type="table"
      class="mx-auto"
    >
      <v-data-table
        id="myTable"
        item-key="id"
        :headers="headerTable"
        :items="list"
        :server-items-length="totalItems"
        :options.sync="options"
        no-data-text="Không có dữ liệu"
        no-results-text="Không có dữ liệu phù hợp"
        :footer-props="{
          itemsPerPageText: 'Dòng mỗi trang:',
          pageText: '{0}-{1} trên {2}',
          itemsPerPageAllText: 'Tất cả',
        }"
        class="elevation-1"
        @click:row="(item) => goToDeviceDetail(item.id)"
        @update:page="updatePagination"
        @update:items-per-page="updatePagination"
      >
        <template v-slot:[`item.code`]="{ item }">
          <v-chip color="purple">
            <span class="white--text">{{ item.code }}</span>
          </v-chip></template
        >
        <template v-slot:[`item.receiveDate`]="{ item }">
          <v-chip color="green" v-if="item.receiveDate != null">
            <span class="white--text">{{ item.receiveDate }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.deliveryStatusName`]="{ item }">
          <v-chip color="orange">
            <span class="white--text">{{ item.deliveryStatusName }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.fixedPlanDate`]="{ item }">
          <v-chip color="error">
            <span class="white--text">{{ item.fixedPlanDate }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.customerName`]="{ item }">
          <v-chip color="orange">
            <span class="white--text">{{ item.customerName }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.customerPhone`]="{ item }">
          <v-chip color="brown">
            <span class="white--text">{{ item.customerPhone }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.revenue`]="{ item }">
          <div v-if="item.revenue != null">
            <v-chip color="black">
              <span class="white--text">{{ item.revenue }}</span>
            </v-chip>
          </div>
        </template>
        <template v-slot:[`item.fixStatusName`]="{ item }">
          <v-chip color="red" v-if="item.fixStatusName == 'Đang sửa'">
            <span class="white--text">{{ item.fixStatusName }}</span>
          </v-chip>
          <v-chip color="green" v-if="item.fixStatusName == 'Đã sửa xong'">
            <span class="white--text">{{ item.fixStatusName }}</span>
          </v-chip>
          <v-chip color="purple" v-if="item.fixStatusName == 'Bảo hành sửa'">
            <span class="white--text">{{ item.fixStatusName }}</span>
          </v-chip>
          <v-chip color="black" v-if="item.fixStatusName == 'Chờ linh kiện'">
            <span class="white--text">{{ item.fixStatusName }}</span>
          </v-chip>
          <v-chip color="orange" v-if="item.fixStatusName == 'Chờ giao cho khách'">
            <span class="white--text">{{ item.fixStatusName }}</span>
          </v-chip>
          <v-chip color="black" v-if="item.fixStatusName == 'Không sửa được'">
            <span class="white--text">{{ item.fixStatusName }}</span>
          </v-chip>
          <v-chip color="blue" v-if="item.fixStatusName == 'Kiểm tra báo giá'">
            <span class="white--text">{{ item.fixStatusName }}</span>
          </v-chip>
          <v-chip color="brown" v-if="item.fixStatusName == 'Khách không sửa'">
            <span class="white--text">{{ item.fixStatusName }}</span>
          </v-chip>
          <v-chip color="yellow" v-if="item.fixStatusName == 'Thu lại máy'">
            <span class="white--text">{{ item.fixStatusName }}</span>
          </v-chip>
        </template>
        <template #footer.prepend>
          <div class="flex-grow flex items-end justify-end mr-4">
            <span>
              <v-menu :max-height="400" :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-cog-outline</v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in headers" :key="index">
                    <v-checkbox v-model="item.model" :label="item.text" />
                  </v-list-item>
                </v-list>
              </v-menu>
            </span>
          </div>
        </template>
      </v-data-table>
    </v-skeleton-loader>
    <v-row class="pt-5">
      <v-col cols="12" sm="auto">
        <v-btn
          min-width="180"
          width="100%"
          block
          color="success"
          @click="createPDF"
          x-large
        >
          <v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
          Xuất file pdf
        </v-btn></v-col
      >
      <v-col cols="12" sm="auto">
        <vue-excel-xlsx
          :data="dataExcel"
          :columns="columns"
          class="btn success"
          :file-name="suaChuaExcelFileName"
          :file-type="'xlsx'"
          :sheet-name="'DỮ LIỆU SỬA CHỮA MÁY'"
        >
          XUẤT FILE EXCEL
        </vue-excel-xlsx></v-col
      ></v-row
    >
  </v-container>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { mapState } from "vuex";
import html2pdf from "html2pdf.js";
import DatePicker from "~/components/atoms/DatePicker.vue";

export default {
  name: "MedicineList",
  components: { DatePicker },
  data() {
    return {
      headers: [
        { text: "ID", value: "id", sortable: true, model: true },
        { text: "Ngày nhận", value: "receiveDate", sortable: true, model: true },
        { text: "Ngày trả", value: "fixedPlanDate", sortable: false, model: true },
        { text: "Sản phẩm", value: "productName", sortable: false, model: true },
        { text: "Khách hàng", value: "customerName", sortable: true, model: true },
        { text: "Điện thoại", value: "customerPhone", sortable: false, model: true },
        { text: "Sửa chữa", value: "fixContent", sortable: false, model: true },
        { text: "Lợi nhuận", value: "revenue", sortable: false, model: true },
        { text: "KTV", value: "technicianId", sortable: false, model: true },
        { text: "Thạng thái sửa", value: "fixStatusName", sortable: false, model: true },
        { text: "Giá tiền", value: "priceFixFormat", sortable: false, model: true },
        { text: "Tạo lúc", value: "createdAt", sortable: false, model: true },
        { text: "Cập nhật", value: "updatedAt", sortable: false, model: true },
      ],
      options: { page: 1, itemsPerPage: 5 },
      list: [],
      searchString: EMPTY,
      sortConditionList: [],
      sortCondition: 1,
      searchConditionList: [],
      searchCondition: 1,
      totalItems: 0,
      isLoading: false,
      menu: false,
      simBranchList: [],
      startDate: null,
      endDate: null,
      fixStatus: null,
      fixStatusList: [
        {
          id: 1,
          name: "Bảo hành sửa",
        },
        {
          id: 2,
          name: "Đang sửa",
        },
        {
          id: 3,
          name: "Chờ linh kiện",
        },
        {
          id: 4,
          name: "Đã sửa xong",
        },
        {
          id: 5,
          name: "Chờ giao cho khách",
        },
        {
          id: 6,
          name: "Không sửa được",
        },
        {
          id: 7,
          name: "Kiểm tra báo giá",
        },
        {
          id: 8,
          name: "Khách không sửa",
        },
      ],
      columns: [
        {
          label: "ID",
          field: "id",
        },
        {
          label: "SĐTKH",
          field: "customerPhone",
        },
        {
          label: "Tên KH",
          field: "customerName",
        },
        {
          label: "Mã sản phẩm",
          field: "productIMEI",
        },
        {
          label: "Ngày nhận",
          field: "receiveDate",
        },
        {
          label: "Ngày dự kiến trả",
          field: "fixedPlanDate",
        },
        {
          label: "Tên sản phẩm",
          field: "productName",
        },
        {
          label: "Mật khẩu máy",
          field: "productLockScreen",
        },
        {
          label: "Tình trạng tiếp nhận",
          field: "receiveStatus",
        },
        {
          label: "Nội dung sửa",
          field: "fixContent",
        },
        {
          label: "Báo giá",
          field: "priceFix",
        },
        {
          label: "Chi phí",
          field: "addCost",
        },
        {
          label: "Bảo hành",
          field: "guarrantyDateName",
        },
        {
          label: "Tình trạng sửa",
          field: "fixStatusName",
        },
        {
          label: "Kỹ thuật viên",
          field: "technicianId",
        },
        {
          label: "Ghi chú",
          field: "note",
        },
      ],
      dataExcel: [],
      suaChuaExcelFileName: null,
    };
  },
  computed: {
    ...mapState({
      role: (state) => state.user.roleName,
    }),
    classStyle() {
      return window.innerWidth <= 640 ? "pb-2" : "pr-2";
    },
    headerTable() {
      return this.headers.filter((item) => item.model);
    },
  },
  async created() {
    this.suaChuaExcelFileName =
      "sua-chua-" + new Date().toLocaleDateString("vi-VN").replaceAll("/", "-");
    const headers = JSON.parse(localStorage.getItem("lephongfix99"));
    if (headers) {
      this.headers = headers;
    }
    this.handleQueryParams();
    await Promise.all([
      this.getData(),
      this.getSortCondition(),
      this.getSearchCondition(),
    ]);
  },
  beforeDestroy() {
    localStorage.setItem("lephongfix99", JSON.stringify(this.headers));
  },
  watch: {
    "$route.query": {
      async handler() {
        if (!Object.keys(this.$route.query).length) {
          this.options = { page: 1, itemsPerPage: 5 };
        }
        await this.getData();
      },
      deep: true,
    },
  },
  methods: {
    async handleQueryParams() {
      this.modelSearch = this.$route.query?.searchString || this.searchString;
      this.searchCondition = this.$route.query?.searchCondition || this.searchCondition;
      this.sortCondition = this.$route.query?.sortCondition || this.sortCondition;
      this.options.page = Number(this.$route.query?.page) || this.options.page;
      this.options.itemsPerPage =
        Number(this.$route.query?.perPage) || this.options.itemsPerPage;
    },
    goToDeviceDetail(id) {
      this.$router.push({
        name: "PhoneFixDetail",
        params: { phonefixId: id },
      });
    },
    createNewPhoneFix() {
      this.$router.push({
        name: "CreatePhoneFix",
      });
    },
    onSearch() {
      this.options.page = 1;
      this.updateQueryParams();
    },
    async updateQueryParams() {
      const object = {};
      if (this.options.page) {
        object.page = this.options.page;
      }
      if (this.options.itemsPerPage) {
        object.perPage = this.options.itemsPerPage;
      }
      if (this.searchString) {
        object.searchString = this.searchString;
      }
      if (this.searchCondition) {
        object.searchCondition = this.searchCondition;
      }
      if (this.sortCondition) {
        object.sortCondition = this.sortCondition;
      }
      if (this.fixStatus) {
        object.fixStatus = this.fixStatus;
      }
      if (this.startDate) {
        object.startDate = this.startDate;
      }
      if (this.endDate) {
        object.endDate = this.endDate;
      }
      try {
        await this.$router.replace({ query: { ...object } });
      } catch {}
    },
    async getData() {
      this.isLoading = true;
      try {
        const { result, totalItems } = await this.$services.phonefixService.getPhoneFixs({
          ...this.$route.query,
        });
        this.totalItems = totalItems;
        this.list = result;
        this.dataExcel = result;
      } catch (err) {
      } finally {
        this.isLoading = false;
      }
    },
    async routeChange(query) {
      query.page = 1;
      query.perPage = 10;
      // query not empty -> append current query
      const _query = { ...this.$route.query, ...query };

      Object.keys(query).forEach((element) => {
        if (!query[element] && typeof query[element] !== "boolean") {
          delete _query[element];
        }
      });

      this.$router.replace({ query: { ..._query } });
      if (this.options.page !== 1) {
        this.options.page = 1;
        return;
      }
      await this.getData();
    },
    async updatePagination() {
      await this.$router.replace({
        query: {
          ...this.$route.query,
          page: this.options.page,
          perPage: this.options.itemsPerPage,
        },
      });
    },
    async getSortCondition() {
      try {
        const data = await this.$services.phonefixService.getPhoneFixSortCondition();
        this.sortConditionList = data;
      } catch (err) {
      } finally {
      }
    },
    async getSearchCondition() {
      try {
        const data = await this.$services.phonefixService.getPhoneFixSearchCondition();
        this.searchConditionList = data;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    onClickDefault() {
      this.menu = false;
      this.sortCondition = null;
      this.onSearch();
    },
    createPDF() {
      html2pdf() // move your config in the .set({...}) function below
        .set({
          filename: "filename",
          html2canvas: {
            dpi: 192,
            scale: 5,
            letterRendering: true,
            useCORS: true,
          },
          jsPDF: {
            unit: "mm",
            format: "a2",
            orientation: "landscape",
          },
        })
        .from(document.getElementById("myTable"))
        .outputPdf() // add this to replace implicite .save() method, which triggers file download
        .get("pdf")
        .then(function (pdfObj) {
          window.open(pdfObj.output("bloburl"), "F");
        });
    },
  },
};
</script>
<style scoped>
.btn {
  border: 2px solid black;
  background-color: white;
  color: black;
  padding: 14px 32px;
  font-size: 16px;
  cursor: pointer;
  color: white !important;
}

/* Green */
.success {
  border-color: #04aa6d;
  color: green;
}

.success:hover {
  background-color: #04aa6d;
  color: white;
}
</style>
